import { Pressable, StyleSheet, Text, View, Dimensions } from 'react-native';
import { extractUrls } from '../../../utils/CommonUtils';
import { useAppNavigation } from '../../navigation';
import { ContentRenderProps } from '../ContentRender';
import React from 'react';
import { TextPopMenu } from './ChatItemsRender';
import { color_3C3C3C } from '../../../assets/style/colors';

const TextRender = (props: ContentRenderProps & { isTalk?: boolean }): React.JSX.Element => {
	const senderIsAdmin = props.adminUids?.includes(props.item.sender) === true;
	const isColor = props.adminColor && props.adminColor.length > 0;
	const textColor =
		isColor && senderIsAdmin ? props.adminColor : props.isSelf ? '#000000' : props.isTalk && props.isTalk ? '#000000' : color_3C3C3C;
	const navigation = useAppNavigation();
	const pdLeft: number = props.pdLeft ?? 12;
	const pdRight: number = props.pdRight ?? 12;
	const urls = extractUrls(props.item.content ?? '');
	
	// 计算第三栏（详情栏）的实际宽度和消息的最大宽度
	const screenWidth = Dimensions.get('window').width;
	const sidebarWidth = 88; // 第一栏宽度
	const listWidth = 340; // 第二栏宽度
	const detailWidth = screenWidth - sidebarWidth - listWidth; // 第三栏宽度
	const msgContentMaxWidth = detailWidth * 0.7; // msgContent 的 maxWidth: 70%
	const maxWidth = msgContentMaxWidth - 40 - 16; // 减去头像(40) 和 marginHorizontal(8*2)

	const handleTextClick = (isUrl: boolean, text: string) => {
		if (props.talkSelectStatus === true) {
			props.onClick?.();
			return;
		}
		if (isUrl) {
			navigation.navigate('CommonWeb', {
				url: text,
				showBack: true,
			});
		}
	};
	
	// 恢复 urls.map 功能，添加严格的过滤
	const validUrls = urls.filter((v) => {
		if (!v || typeof v !== 'object') return false;
		const text = v.text;
		return text != null && typeof text === 'string' && text.trim().length > 0;
	});

	const TextComponent = (
		<View style={{ flexDirection: 'column' }}>
			<View style={[styles.emojiTextView, { paddingLeft: pdLeft, paddingRight: pdRight, maxWidth: maxWidth }]}>
				{validUrls.length > 0 ? (
					validUrls.map((v, index) => {
						const isUrl = v.isUrl;
						const text = v.text;
						// 再次检查 text 是否有效
						if (!text || typeof text !== 'string' || text.trim().length === 0) {
							return null;
						}
						if (isUrl) {
							return (
								<Text
									onLongPress={props.onLongPress}
									onPress={() => handleTextClick(isUrl, text)}
									disabled={props.talkSelectStatus === true || props.disabled == true}
									style={{
										color: isUrl ? '#3079ED' : textColor,
										fontFamily: '',
										fontWeight: props.isBold && senderIsAdmin ? 'bold' : 'normal',
										lineHeight: 20,
									}}
									key={`text-${index}`}
								>
									{text}
								</Text>
							);
						}
						return (
							<Text
								style={{
									color: textColor,
									fontFamily: '',
									fontWeight: props.isBold && senderIsAdmin ? 'bold' : 'normal',
									fontSize: 15,
									lineHeight: 20,
								}}
								key={`text-${index}`}
							>
								{text}
							</Text>
						);
					}).filter((item) => item !== null)
				) : (
					props.item.content && typeof props.item.content === 'string' && props.item.content.trim().length > 0 ? (
						<Text style={{ color: textColor, fontSize: 15 }}>{props.item.content}</Text>
					) : null
				)}
			</View>
			{props.translate != null && typeof props.translate === 'string' && props.translate.trim().length > 0 && <TextPopMenu isSelf={props.isSelf} translate={props.translate} />}
		</View>
	);

	return TextComponent;
};

export const TextContentRender = React.memo(TextRender, (prevProps, nextProps) => {
	return prevProps === nextProps;
});

const styles = StyleSheet.create({
	emojiTextView: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
	},
});
